(function () {
  var nativeFetch = window.fetch.bind(window);
  var lastGoodCart = null;
  var pendingCart = null;
  var syncTimers = [];

  function config() {
    var el = document.querySelector('[data-oyen-cart-limits]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* OYEN-CUSTOM: isRefurb start */
  function extraRefurbMap() {
    var map = {};
    document.querySelectorAll('[data-oyen-refurbished-map]').forEach(function (el) {
      try {
        var o = JSON.parse(el.textContent);
        Object.keys(o || {}).forEach(function (k) {
          if (o[k] === true) map[String(k)] = true;
        });
      } catch (e) {}
    });
    return map;
  }

  function isRefurb(cfg, variantId) {
    if (variantId == null || variantId === '') return false;
    var id = String(variantId);
    if (cfg && cfg.lines && cfg.lines[id] === true) return true;
    if (cfg && cfg.productLines && cfg.productLines[id] === true) {
      cfg.lines = cfg.lines || {};
      cfg.lines[id] = true;
      return true;
    }
    if (extraRefurbMap()[id]) {
      if (cfg) {
        cfg.lines = cfg.lines || {};
        cfg.lines[id] = true;
      }
      return true;
    }
    return false;
  }
  /* OYEN-CUSTOM: isRefurb end */

  function countsFromCart(cart, cfg) {
    var regular = 0;
    var refurbished = 0;
    (cart.items || []).forEach(function (item) {
      var id = item.variant_id || item.id;
      if (isRefurb(cfg, id)) refurbished += item.quantity;
      else regular += item.quantity;
    });
    return { regular: regular, refurbished: refurbished };
  }

  function limitMessage(c, cfg) {
    if (!c || !cfg) return null;
    if (c.refurbished > Number(cfg.maxRefurbished)) return cfg.msgRefurbished;
    if (c.regular > Number(cfg.maxRegular)) return cfg.msgRegular;
    return null;
  }

  function liveCart() {
    return pendingCart || lastGoodCart;
  }

  function cloneCart(cart) {
    return JSON.parse(JSON.stringify(cart || { items: [] }));
  }

  function remainingForVariant(cart, cfg, variantId) {
    var c = countsFromCart(cart, cfg);
    if (isRefurb(cfg, variantId)) {
      return Math.max(0, Number(cfg.maxRefurbished) - c.refurbished);
    }
    return Math.max(0, Number(cfg.maxRegular) - c.regular);
  }

  function maxQtyForItem(cart, cfg, item) {
    return item.quantity + remainingForVariant(cart, cfg, item.variant_id || item.id);
  }

  function inAddForm(el) {
    return !!(el && el.closest && el.closest('form[action*="/cart/add"], product-form, .product-form'));
  }

  function inCartUi(el) {
    if (!el || !el.closest || inAddForm(el)) return false;
    return !!(
      el.closest('cart-drawer, .cart-drawer, #CartDrawer, #cart-drawer, cart-drawer-items') ||
      el.closest('form[action="/cart"], form[action$="/cart"], form[id="cart"], form[data-type="add-to-cart-form"]') ||
      el.closest('#MainCart, #main-cart, #Cart, cart-items, .cart-items, .main-cart, .cart-page') ||
      el.closest('[data-oyen-cart-limits]')
    );
  }

  function showError(msg) {
    var nodes = document.querySelectorAll('[data-oyen-cart-limit-error]');
    nodes.forEach(function (el) {
      el.hidden = !msg;
      el.innerHTML = msg ? '<p>' + msg + '</p>' : '';
    });
  }

  function disableCheckout(disabled) {
    document.querySelectorAll('[name="checkout"], [href="/checkout"]').forEach(function (el) {
      if ('disabled' in el) el.disabled = disabled;
      el.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      el.style.pointerEvents = disabled ? 'none' : '';
    });
  }

  function findItem(cart, payload) {
    var items = (cart && cart.items) || [];
    if (payload && payload.line != null) return items[Number(payload.line) - 1] || null;
    if (payload && payload.id != null) {
      var id = String(payload.id);
      for (var i = 0; i < items.length; i++) {
        if (
          items[i].key === payload.id ||
          String(items[i].variant_id) === id ||
          String(items[i].id) === id
        ) {
          return items[i];
        }
      }
    }
    return null;
  }

  function itemFromWrap(wrap, cart) {
    if (!wrap || !cart) return null;
    var input = wrap.querySelector('input[type="number"], input[name^="updates"]');
    var vid = String(
      (input &&
        (input.getAttribute('data-quantity-variant-id') ||
          input.getAttribute('data-variant-id') ||
          input.getAttribute('data-quantity-item'))) ||
        wrap.getAttribute('data-quantity-variant-id') ||
        wrap.getAttribute('data-variant-id') ||
        wrap.getAttribute('data-key') ||
        ''
    );
    var name = (input && input.getAttribute('name')) || '';
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var id = String(item.variant_id || item.id);
      if (vid && (vid === id || vid === String(item.key))) return item;
      if (name && name.indexOf(item.key) !== -1) return item;
    }
    if (input && cart.items.length === 1) return cart.items[0];
    return null;
  }

  function plusEl(wrap) {
    if (!wrap) return null;
    var named = wrap.querySelector('button[name="plus"], [name="plus"], button[data-action="increase"], [data-quantity-plus]');
    if (named) return named;
    var buttons = wrap.querySelectorAll('button');
    return buttons.length >= 2 ? buttons[buttons.length - 1] : null;
  }

  function syncCartSteppers(cart) {
    if (!cart) return;
    document.querySelectorAll('quantity-input, .quantity, [data-quantity]').forEach(function (wrap) {
      if (!inCartUi(wrap)) return;
      var item = itemFromWrap(wrap, cart);
      var input = wrap.querySelector('input[type="number"], input[name^="updates"]');
      if (!item || !input) return;
      if (String(input.value) !== String(item.quantity)) {
        input.value = String(item.quantity);
      }
    });
  }

  function applyUI(cart, cfg, warnMsg) {
    var over = !!(cfg && cart && limitMessage(countsFromCart(cart, cfg), cfg));
    showError(warnMsg || null);
    disableCheckout(over);
    var jsonEl = document.querySelector('[data-oyen-cart-limits]');
    if (jsonEl && cfg && cart) {
      var c = countsFromCart(cart, cfg);
      cfg.regular = c.regular;
      cfg.refurbished = c.refurbished;
      jsonEl.textContent = JSON.stringify(cfg);
    }
    syncCartSteppers(cart);
  }

  function scheduleSync(cart, cfg, msg) {
    applyUI(cart, cfg, msg);
    syncTimers.forEach(clearTimeout);
    syncTimers = [0, 30, 80, 200, 500].map(function (t) {
      return setTimeout(function () {
        applyUI(cart, cfg, msg);
      }, t);
    });
  }

  function getCart() {
    return nativeFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function fakeCartResponse(cart) {
    return new Response(JSON.stringify(cart || { items: [] }), {
      status: 200,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  function isCartWrite(url) {
    url = String(url || '');
    return (
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1
    );
  }

  function parseBody(body) {
    if (!body) return null;
    if (typeof body === 'string') {
      try {
        return JSON.parse(body);
      } catch (e) {
        var o = {};
        new URLSearchParams(body).forEach(function (v, k) {
          o[k] = v;
        });
        return o;
      }
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var fd = {};
      body.forEach(function (v, k) {
        fd[k] = v;
      });
      return fd;
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      var usp = {};
      body.forEach(function (v, k) {
        usp[k] = v;
      });
      return usp;
    }
    return null;
  }

  function stringifyLike(original, payload) {
    if (typeof original === 'string') {
      try {
        JSON.parse(original);
        return JSON.stringify(payload);
      } catch (e) {
        var p = new URLSearchParams();
        Object.keys(payload).forEach(function (k) {
          if (payload[k] != null && typeof payload[k] !== 'object') p.set(k, String(payload[k]));
        });
        return p.toString();
      }
    }
    if (typeof FormData !== 'undefined' && original instanceof FormData) {
      var fd = new FormData();
      Object.keys(payload).forEach(function (k) {
        if (payload[k] != null && typeof payload[k] !== 'object') fd.set(k, String(payload[k]));
      });
      return fd;
    }
    return JSON.stringify(payload);
  }

  function extractPayload(input, init) {
    if (init && init.body) {
      return Promise.resolve({ payload: parseBody(init.body), rawBody: init.body, fromInit: true });
    }
    if (typeof Request !== 'undefined' && input instanceof Request) {
      return input
        .clone()
        .text()
        .then(function (text) {
          return { payload: parseBody(text), rawBody: text, fromInit: false };
        })
        .catch(function () {
          return { payload: null, rawBody: null, fromInit: false };
        });
    }
    return Promise.resolve({ payload: null, rawBody: null, fromInit: true });
  }

  function setItemQty(cart, item, qty) {
    (cart.items || []).forEach(function (line) {
      if (line.key === item.key) line.quantity = qty;
    });
  }

  function gatePayload(url, payload) {
    var cfg = config();
    var cart = liveCart();
    if (!cfg || !cart || !payload) return { allow: true };

    if (url.indexOf('/cart/add') !== -1) {
      var addId = payload.id;
      var addQty = Number(payload.quantity != null ? payload.quantity : 1);
      if (payload.items && payload.items[0]) {
        addId = payload.items[0].id;
        addQty = Number(payload.items[0].quantity || 1);
      }
      var room = remainingForVariant(cart, cfg, addId);
      var addMsg = isRefurb(cfg, addId) ? cfg.msgRefurbished : cfg.msgRegular;
      if (room <= 0) return { block: true, msg: addMsg };
      if (addQty > room) {
        payload.quantity = room;
        if (payload.items && payload.items[0]) payload.items[0].quantity = room;
        return { allow: true, msg: addMsg, payload: payload, clamp: true };
      }
      return { allow: true };
    }

    if (payload.quantity == null && !payload.updates) return { allow: true };

    if (payload.updates) {
      return { allow: true };
    }

    var qty = Number(payload.quantity);
    var item = findItem(cart, payload);
    if (!item) return { allow: true };
    if (qty <= item.quantity) return { allow: true };

    var max = maxQtyForItem(cart, cfg, item);
    var lineMsg = isRefurb(cfg, item.variant_id || item.id)
      ? cfg.msgRefurbished
      : cfg.msgRegular;

    if (qty > max) {
      if (item.quantity >= max) return { block: true, msg: lineMsg };
      payload.quantity = max;
      return { allow: true, msg: lineMsg, payload: payload, clamp: true, item: item, qty: max };
    }
    return { allow: true, item: item, qty: qty };
  }

  function rememberPending(item, qty) {
    if (!lastGoodCart || !item) return;
    pendingCart = cloneCart(lastGoodCart);
    setItemQty(pendingCart, item, qty);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!isCartWrite(url)) return nativeFetch.apply(this, arguments);

    var args = arguments;
    var cfg = config();

    return extractPayload(input, init).then(function (extracted) {
      var gated = gatePayload(url, extracted.payload);

      if (gated.block) {
        pendingCart = null;
        scheduleSync(lastGoodCart, cfg, gated.msg);
        return fakeCartResponse(lastGoodCart);
      }

      if (gated.item && gated.qty != null) rememberPending(gated.item, gated.qty);

      var request;
      if (gated.clamp && gated.payload) {
        var newBody = stringifyLike(extracted.rawBody, gated.payload);
        var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
        if (typeof newBody === 'string' && newBody.charAt(0) !== '{') {
          headers['Content-Type'] = 'application/x-www-form-urlencoded';
        }
        request = nativeFetch(url, {
          method: (init && init.method) || 'POST',
          credentials: 'same-origin',
          headers: headers,
          body: typeof newBody === 'string' ? newBody : JSON.stringify(gated.payload),
        });
      } else {
        request = nativeFetch.apply(window, args);
      }

      return request.then(function (res) {
        if (!res.ok) return res;
        return res
          .clone()
          .json()
          .then(function (data) {
            var cart = data && data.items ? data : null;
            return (cart ? Promise.resolve(cart) : getCart()).then(function (fresh) {
              var over = cfg && limitMessage(countsFromCart(fresh, cfg), cfg);
              pendingCart = null;
              if (!over) lastGoodCart = fresh;
              scheduleSync(over ? lastGoodCart || fresh : fresh, cfg, gated.msg || null);
              return res;
            });
          })
          .catch(function () {
            pendingCart = null;
            return res;
          });
      });
    });
  };

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var wrap = t.closest('quantity-input, .quantity, [data-quantity]');
      if (wrap && inCartUi(wrap)) {
        var btn = t.closest('button, [role="button"]');
        var isPlus = btn && (btn.getAttribute('name') === 'plus' || btn.getAttribute('data-action') === 'increase' || plusEl(wrap) === btn);
        if (isPlus) {
          var cfg = config();
          var item = itemFromWrap(wrap, liveCart());
          if (cfg && item) {
            var max = maxQtyForItem(liveCart(), cfg, item);
            if (item.quantity >= max) {
              e.preventDefault();
              e.stopImmediatePropagation();
              var input = wrap.querySelector('input[type="number"]');
              if (input) input.value = String(item.quantity);
              scheduleSync(
                lastGoodCart,
                cfg,
                isRefurb(cfg, item.variant_id || item.id) ? cfg.msgRefurbished : cfg.msgRegular
              );
            }
          }
          return;
        }
      }

      var checkout = t.closest('[name="checkout"], [href="/checkout"]');
      if (!checkout) return;
      e.preventDefault();
      e.stopPropagation();
      var cfg2 = config();
      getCart().then(function (cart) {
        var msg = cfg2 ? limitMessage(countsFromCart(cart, cfg2), cfg2) : null;
        if (msg) {
          lastGoodCart = lastGoodCart || cart;
          scheduleSync(lastGoodCart, cfg2, msg);
          return;
        }
        lastGoodCart = cart;
        window.location.href = '/checkout';
      });
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (e) {
      var input = e.target;
      if (!input || input.type !== 'number' || !inCartUi(input)) return;
      if (e.key !== 'ArrowUp' && e.key !== 'Up') return;
      var cfg = config();
      var wrap = input.closest('quantity-input, .quantity, [data-quantity]');
      var item = itemFromWrap(wrap, liveCart());
      if (!cfg || !item) return;
      if (item.quantity >= maxQtyForItem(liveCart(), cfg, item)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        input.value = String(item.quantity);
        scheduleSync(
          lastGoodCart,
          cfg,
          isRefurb(cfg, item.variant_id || item.id) ? cfg.msgRefurbished : cfg.msgRegular
        );
      }
    },
    true
  );

  getCart().then(function (cart) {
    var cfg = config();
    if (!cfg) return;
    lastGoodCart = cart;
    applyUI(cart, cfg);
  });
})();